import React from "react";

const DietPlanLoader = () => {
  return (
    <div className="text-[24px] text-center text-blue-500 font-semibold flex flex-col justify-center items-center">
      {/* <p>Please wait</p> */}
      {/* <p>Meal plan in progress</p> */}

      <div className="flex justify-center items-start h-[fit-content]">
        <div className="flex space-x-1 justify-center items-end h-16">
          <div className="w-2 bg-blue-600 animate-wave [animation-delay:0.1s]"></div>
          <div className="w-2 bg-blue-600 animate-wave [animation-delay:0.2s]"></div>
          <div className="w-2 bg-blue-600 animate-wave [animation-delay:0.3s]"></div>
          <div className="w-2 bg-blue-600 animate-wave [animation-delay:0.4s]"></div>
          <div className="w-2 bg-blue-600 animate-wave [animation-delay:0.5s]"></div>
        </div>
      </div>
    </div>
  );
};

export default DietPlanLoader;
